import { render, staticRenderFns } from "./title_nobg.vue?vue&type=template&id=ad422474&scoped=true&"
import script from "./title_nobg.vue?vue&type=script&lang=js&"
export * from "./title_nobg.vue?vue&type=script&lang=js&"
import style0 from "./title_nobg.vue?vue&type=style&index=0&id=ad422474&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad422474",
  null
  
)

export default component.exports